import React from "react";
import "./profileStaffSkeleton.css";

const ProfileStaffSkeleton = () => {
	return (
		<div className="sf-staffskel-page">

			{/* ===========================
			    HEADER (Avatar + Name + Bio)
			=========================== */}
			<div className="sf-staffskel-header">
				<div className="sf-staffskel-avatar shimmer"></div>

				<div className="sf-staffskel-headtext">
					<div className="sf-staffskel-line w-50 shimmer"></div>
					<div className="sf-staffskel-line w-30 shimmer"></div>
				</div>

				<div className="sf-staffskel-editbtn shimmer"></div>
			</div>

			{/* ===========================
			    SERVICES SECTION
			=========================== */}
			<div className="sf-staffskel-services">
				<div className="sf-staffskel-servicetitle shimmer"></div>

				<div className="sf-staffskel-servicecount shimmer"></div>

				<div className="sf-staffskel-service-list">
					{Array.from({ length: 4 }).map((_, i) => (
						<div key={i} className="sf-staffskel-service-item shimmer"></div>
					))}
				</div>
			</div>

			{/* ===========================
			    CONTACT + HOURS SIDEBAR
			=========================== */}
			<div className="sf-staffskel-sidebar">
				<div className="sf-staffskel-sideblock shimmer"></div>
				<div className="sf-staffskel-sideblock shimmer"></div>
				<div className="sf-staffskel-sideblock shimmer"></div>
			</div>

		</div>
	);
};

export default ProfileStaffSkeleton;
